<template>
  <div class="check-list">
    <Modal
      ref="modal"
      modalType="large-modal"
      :modalId="`checklist-${+new Date()}`"
    >
      <div
        class="modal-header"
        solt="modal-header"
      >
        <div class="emphasis">
          {{ $t(`terms.${regionName}.finalDocuments.submissionChecklist.title`) }}
        </div>
      </div>
      <div
        class="check-list__box"
        slot="content"
      >
        <div class="check-list__subtilte emphasis">
          {{ $t(`terms.${regionName}.finalDocuments.submissionChecklist.subTitle`) }}
        </div>
        <div class="last-update">
          <div class="last-update__text">
            {{ $t(`terms.${regionName}.finalDocuments.submissionChecklist.subTilteTips`) }}
          </div>
        </div>
        <div class="check-list__content">
          <div
            class="check-list__section"
            v-for="(section, index) in sections"
            :key="section.type"
          >
            <div
              class="check-list__section-title"
              v-if="section.type"
            >{{ [index+1, section.type].join(' ') }}</div>
            <ol
              class="check-list__group"
              v-for="group in section.itemGroup"
              :key="group.title"
            >
              <div class="check-list__group-title">
                {{ group.title }}
              </div>
              <ol class="check-list__section-items-box">
                <li
                  class="check-list__section-item"
                  v-for="item in group.content"
                  :key="item"
                  v-html="item"
                />
              </ol>
            </ol>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from '@/controls/Modal'
export default {
  name: 'SubmissionChecklist',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('regions', ['regionName']),
    sections () {
      return this.$t(`terms.${this.regionName}.finalDocuments.submissionChecklist.sections`)
    },
  },
  methods: {
    open () {
      this.$refs.modal.open()
    },
    close () {
      this.$refs.modal.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.emphasis {
  font-weight: bold
}
.check-list {
  &__box {
    margin-top: 20px;
    font-size: 14px;
  }
  &__group {
    margin-left: 0;
  }
  &__content {
    margin-top: 20px;
  }
  &__section-title {
    font-weight: bold;
    margin-bottom: 14px;
  }
  &__section-items-box {
    margin-top: 10px;
    padding-left: 20px;
    line-height: 2.14
  }
}
</style>
